<template>
    <div class="rows overflow-wrapper" style="position: relative;">
        <div v-if="item.idNadrazenePodani !== -1" class="bubble-sticky">
            <div class="bubble">
                Toto je dodatečné podání ({{ item.n }} z {{ item.q }}) k&nbsp;nadřazenému podání {{ item.dossNP }} ze&nbsp;dne {{ formatDate(item.odeslanoNP) }}
            </div>
        </div>

        <div class="overflow-container">
            <div style="margin-bottom: 10px;">
                <table class="table-border-none">
                    <tr>
                        <td style="padding-left: 0;">Zakázka:</td>
                        <td>
                            <select v-model="item.idZakazka" style="width: 400px;">
                                <option :value="-1">&lt; vyberte zakázku &gt;</option>
                                <option v-for="(z, i) in sortedZakazka" :key="i" :value="z.id">{{ z.cisloZakazky + ' - ' + z.nazev }}</option>
                            </select>
                            <span class="required">*</span>
                        </td>
                    </tr>
                    <tr v-if="idPodani !== undefined && idPodani !== -1">
                        <td style="padding-left: 0;">Nadřazené podání:</td>
                        <td>
                            <select v-model="item.idNadrazenePodani" style="width: 400px;">
                                <option :value="-1">&lt; vyberte podání &gt;</option>
                                <option v-for="(p, i) in podani" :key="i" :value="p.id">{{ p.predmet }}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Instituce:</td>
                        <td>
                            <select v-model="item.iddoss" style="width: 400px;">
                                <option :value="-1">&lt; vyberte instituci &gt;</option>
                                <option v-for="(d, i) in sortedInstituce" :key="i" :value="d.id">{{ d.kategorie + ' - ' + d.nazev }}</option>
                            </select>
                            <span class="required">*</span>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Pracoviště:</td>
                        <td>
                            <select v-model="item.iddossPrac" style="width: 400px;">
                                <option :value="-1">&lt; vyberte pracoviště &gt;</option>
                                <option v-for="(p, i) in sortedPracoviste" :key="i" :value="p.id">{{ p.zkratka + ' - ' + p.pracoviste }}</option>
                            </select>
                            <span class="required">*</span>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" style="padding-left: 0;">Kontaktní osoba DOSS:</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 30px;">Pracovník:</td>
                        <td><input v-model="item.dossKontaktPracovnik" style="width: 400px;" /></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 30px;">Telefon:</td>
                        <td><input v-model="item.dossKontaktTelefon" style="width: 400px;" /></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 30px;">E-mail:</td>
                        <td><input v-model="item.dossKontaktEmail" style="width: 400px;" /></td>
                    </tr>
                    <tr><td colspan="2">&nbsp;</td></tr>
                    <tr>
                        <td style="padding-left: 0;">Předmět:</td>
                        <td><input v-model="item.predmet" style="width: 400px;" /><span class="required">*</span></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Druh podání - žádost o:</td>
                        <td>
                            <select v-model="item.idDruhPodani" style="width: 200px;">
                                <option :value="-1">&lt; vyberte druh podání &gt;</option>
                                <option v-for="(dp, i) in sortedDruhPodani" :key="i" :value="dp.id">{{ dp.druh }}</option>
                            </select>
                            <span class="required">*</span>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Odpovědná osoba:</td>
                        <td>
                            <select v-model="item.idOdpovednaOsoba" style="width: 400px;">
                                <option :value="-1">&lt; vyberte uživatele &gt;</option>
                                <option v-for="(u, i) in sortedUzivatel" :key="i" :value="u.id">{{ u.prijmeni + ' ' + u.jmeno + ' (' + u.email + ')' }}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Odesláno:</td>
                        <td>
                            <Datepicker
                                v-model="this.item.datumOdeslani"
                                :clearable="true"
                                :locale="locale"
                                :inputFormat="dateFormat"
                                :typeable="true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" style="padding-left: 0;">Předpokládaná lhůta k vyřízení:&nbsp;{{ formattedPredpokLhuta }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Lhůta k vyřízení:</td>
                        <td>
                            <Datepicker
                                v-model="this.item.lhutaKVyrizeni"
                                :clearable="true"
                                :locale="locale"
                                :inputFormat="dateFormat"
                                :typeable="true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Číslo jednací podání:</td>
                        <td><input v-model="item.cisloJednaci" style="width: 200px;" /></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0; vertical-align: top;">Příloha podání:</td>
                        <td>
                            <div><input type="file" id="filePodani" ref="filePodani" style="width: 400px; padding-left: 0;" /></div>
                            <div v-html="prilohaPodani"></div>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0; vertical-align: top;">Dokumentace:</td>
                        <td>
                            <input v-model="this.dokumentace" style="width: 375px;" />
                            <span @click="addCesta" class="selectListButton" style="margin-left: 2px;">+</span>
                            <div><input type="file" id="fileDokumentace" ref="fileDokumentace" style="width: 400px; padding-left: 0;" /></div>
                            <div class="selectList">
                                <div v-for="(o, i) in item.odkazy" :key="i" class="selectListItem">
                                    <span @click="removeCesta(o)" class="selectListButton">-</span>
                                    {{ o }}
                                </div>
                                <div v-for="(s, i) in prilohy" :key="i" class="selectListItem">
                                    <span v-if="s.typ === 2" @click="removePriloha(s.id)" class="selectListButton">-</span>
                                    <span v-if="s.typ === 2" v-html="priloha(s.id)" style="margin-left: 5px;"></span>
                                    <span v-else style="margin-left: 23px;">{{ s.nazev }}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr><td colspan="2">&nbsp;</td></tr>
                    <tr>
                        <td style="padding-left: 0;">Stanovisko vydáno:</td>
                        <td>
                            <Datepicker
                                v-model="this.item.datumVydaniStanoviska"
                                :clearable="true"
                                :locale="locale"
                                :inputFormat="dateFormat"
                                :typeable="true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Přijetí stanoviska:</td>
                        <td>
                            <Datepicker
                                v-model="this.item.datumPrijetiStanoviska"
                                :clearable="true"
                                :locale="locale"
                                :inputFormat="dateFormat"
                                :typeable="true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Číslo jednací odesílatele:</td>
                        <td><input v-model="item.cisloJednaciVydani" style="width: 200px;" /></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Druh stanoviska:</td>
                        <td>
                            <select v-model="item.idDruhStanoviska" style="width: 200px;">
                                <option :value="-1">&lt; vyberte druh stanoviska &gt;</option>
                                <option v-for="(ds, i) in sortedDruhStanoviska" :key="i" :value="ds.id">{{ ds.druh }}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Platnost stanoviska:</td>
                        <td>
                            <div class="cols">
                                <div style="width: 195px;">
                                    <Datepicker
                                        v-model="this.item.platnostStanoviska"
                                        :clearable="true"
                                        :locale="locale"
                                        :inputFormat="dateFormat"
                                        :typeable="true"
                                    />
                                </div>
                                <div style="padding-top: 3px;"><input type="checkbox" v-model="item.platnostNeomezene" @change="platnostNeomezeneChecked" />Neomezeně</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0; vertical-align: top;">Přílohy stanoviska:</td>
                        <td>
                            <div><input type="file" id="fileStanovisko" ref="fileStanovisko" style="width: 400px; padding-left: 0;" /></div>
                            <!-- <div v-html="prilohaStanoviska"></div> -->
                            <div class="selectList">
                                <div v-for="(s, i) in stanoviska" :key="i" class="selectListItem">
                                    <span v-if="s.typ === 1" @click="removeStanovisko(s.id)" class="selectListButton">-</span>
                                    <input type="checkbox" v-model="s.export" />Exp
                                    <span v-if="s.typ === 1" v-html="stanovisko(s.id)" style="margin-left: 5px;"></span>
                                    <span v-else style="margin-left: 23px;">{{ s.nazev }}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr><td colspan="2">&nbsp;</td></tr>
                    <tr>
                        <td style="padding-left: 0;">Stav:</td>
                        <td>
                            <select v-model="item.idStatus" style="width: 200px;">
                                <option :value="-1">&lt; vyberte status &gt;</option>
                                <option v-for="(s, i) in this.status" :key="i" :value="s.id">{{ s.nazev }}</option>
                            </select>
                            <span class="required">*</span>
                        </td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0; vertical-align: top;">Poznámka:</td>
                        <td><textarea v-model="item.poznamka" style="width: 600px; height: 200px; resize: none;"></textarea></td>
                    </tr>
                </table>
            </div>
            <div class="cols" style="gap: 10px; margin-top: 10px;">
                <button @click="saveItem(false)">Uložit</button>
                <button v-if="itemId !== -1" @click="saveItem(true)">Uložit a zavřít</button>
                <button v-if="itemId !== -1" @click="close">Zavřít</button>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api/api.js'
    import { cs } from 'date-fns/locale'
    import Datepicker from 'vue3-datepicker'
    import dayjs from 'dayjs'

    export default {
        name: 'EditPodani',
        props: ['itemId', 'isEditor', 'isAdmin', 'idUser', 'idZakazka', 'idPodani'],
        components: {
            Datepicker
        },
        data() {
            return {
                locale: cs,
                dateFormat: 'dd.MM.yyyy',
                item: {
                    // 'id': -1,
                    // 'idZakazka': -1,
                    // 'idNadrazenePodani': -1,
                    // 'iddoss': -1,
                    // 'iddossPrac': -1,
                    // 'dossKontaktEmail': '',
                    // 'dossKontaktPracovnik': '',
                    // 'dossKontaktTelefon': '',
                    // 'poradiPodani': 0,
                    // 'poradiPodaniInstituce': 0,
                    // 'predmet': '',
                    // 'idDruhPodani': -1,
                    // 'idOdpovednaOsoba': -1,
                    // 'datumOdeslani': null,
                    // 'predpokLhuta': null,
                    // 'lhutaKVyrizeni': null,
                    // 'cisloJednaci': '',
                    // 'datumVydaniStanoviska': null,
                    // 'datumPrijetiStanoviska': null,
                    // 'cisloJednaciVydani': '',
                    // 'idDruhStanoviska': -1,
                    // 'platnostStanoviska': null,
                    // 'idStatus': -1,
                    // 'odkazy': [],
                    // 'soubory': [],
                    // 'zakazka': '',
                    // 'instituce': '',
                    // 'pracoviste': '',
                    // 'druhPodani': '',
                    // 'odpovednaOsoba': '',
                    // 'druhStanoviska': '',
                    // 'status': '',
                    // 'gRepre': '',
                    // 'cislo': '',
                    // 'platnostNeomezene': false,
                    // 'poznamka': '',
                    // 'n': 0,
                    // 'q': 0,
                    // 'dossNP': '',
                    // 'odeslanoNP': null
                },
                zakazka: [],
                instituce: [],
                pracoviste: [],
                druhPodani: [],
                uzivatel: [],
                druhStanoviska: [],
                status: [],
                dokumentace: '',
                podani: []
            }
        },
        computed: {
            sortedZakazka() {
                return this.zakazka
                    .filter(z => z.stav == 0)
                    .slice()
                    .sort((a, b) => (a.cisloZakazky + ':' + a.nazev).localeCompare((b.cisloZakazky + ':' + b.nazev), 'cz'))
            },
            sortedInstituce() {
                return this.instituce
                    .slice()
                    .sort((a, b) => (a.nazev + ':' + a.kategorie).localeCompare((b.nazev + ':' + b.kategorie), 'cz'))
            },
            sortedPracoviste() {
                return this.pracoviste
                    .slice()
                    .sort((a, b) => (a.zkratka + ':' + a.pracoviste).localeCompare((b.zkratka + ':' + b.pracoviste), 'cz'))
            },
            sortedDruhPodani() {
                return this.druhPodani
                    .slice()
                    .sort((a, b) => a.druh.localeCompare(b.druh, 'cz'))
            },
            sortedUzivatel() {
                return this.uzivatel
                    .slice()
                    .sort((a, b) => (a.prijmeni + ':' + a.jmeno).localeCompare((b.prijmeni + ':' + b.jmeno), 'cz'))
            },
            sortedDruhStanoviska() {
                return this.druhStanoviska
                    .slice()
                    .sort((a, b) => a.druh.localeCompare(b.druh, 'cz'))
            },
            formattedPredpokLhuta() {
                return this.item.predpokLhuta !== null ? dayjs(this.item.predpokLhuta).format('D.M.YYYY') : ''
            },
            prilohaPodani() {
                if (this.item.soubory === undefined || this.item.soubory.length === 0)
                    return ''
                let index = this.item.soubory.findIndex(s => s.typ === 0)
                if (index === -1)
                    return ''
                if (this.item.soubory[index].id === -1)
                    return this.item.soubory[index].nazev
                else
                    return '<a target="_blank" href="' + process.env.VUE_APP_API_URL + '/Podani/download?id=' + this.item.soubory[index].id + '">' + this.item.soubory[index].nazev + '</a>'
            },
            // prilohaStanoviska() {
            //     if (this.item.soubory === undefined || this.item.soubory.length === 0)
            //         return ''
            //     let index = this.item.soubory.findIndex(s => s.typ === 1)
            //     if (index === -1)
            //         return ''
            //     if (this.item.soubory[index].id === -1)
            //         return this.item.soubory[index].nazev
            //     else
            //         return '<a target="_blank" href="' + process.env.VUE_APP_API_URL + '/Podani/download?id=' + this.item.soubory[index].id + '">' + this.item.soubory[index].nazev + '</a>'
            // },
            prilohy() {
                if (this.item.soubory === undefined || this.item.soubory.length === 0)
                    return []
                return this.item.soubory.filter(a => a.typ === 2 || a.typ === -1)
            },
            stanoviska() {
                if (this.item.soubory === undefined || this.item.soubory.length === 0)
                    return []
                return this.item.soubory.filter(s => s.typ === 1)
            }
        },
        watch: {
            'item.idZakazka'(newVal, oldVal) {
                if (this.idPodani !== -1 && oldVal === -1 && oldVal !== newVal) {
                    this.$progress.start()
                    api.getPodaniForUser(this.idUser, newVal)
                    .then(response => {
                        this.podani = response.data
                        this.item.idNadrazenePodani = this.idPodani
                    })
                    .catch(error => { 
                        console.log('Error: ', error)
                    })
                    this.$progress.finish()
                }
            },
            'item.iddoss'(newVal, oldVal) {
                if (oldVal !== newVal) {
                    if (this.pracoviste.length > 0)
                        this.item.iddossPrac = -1
                    this.$progress.start()
                    api.getDOSSPracForDOSS(this.item.iddoss)
                    .then(response => {
                        this.pracoviste = response.data
                    })
                    .catch(error => { 
                        console.log('Error: ', error)
                    })
                    this.$progress.finish()
                }
            },
            'item.datumOdeslani'() {
                this.item.predpokLhuta = this.item.datumOdeslani
                if (this.item.predpokLhuta !== null)
                    this.item.predpokLhuta = dayjs(this.item.predpokLhuta).add(30, 'day').toDate()
            }
        },
        methods: {
            load() {
                this.$progress.start()
                if (this.isEditor || this.isAdmin) {
                    api.getZakazka()
                    .then(response => {
                        this.zakazka = response.data
                    })
                    .catch(error => { 
                        console.log('Error: ', error)
                    })
                }
                else {
                    api.getZakazkaForUser(this.idUser)
                    .then(response => {
                        this.zakazka = response.data
                    })
                    .catch(error => { 
                        console.log('Error: ', error)
                    })
                }

                api.getDOSS()
                .then(response => {
                    this.instituce = response.data
                })
                .catch(error => { 
                    console.log('Error: ', error)
                })

                api.getDruhPodani()
                .then(response => {
                    this.druhPodani = response.data
                })
                .catch(error => { 
                    console.log('Error: ', error)
                })

                api.getUzivatel()
                .then(response => {
                    this.uzivatel = response.data
                })
                .catch(error => { 
                    console.log('Error: ', error)
                })

                api.getDruhStanoviska()
                .then(response => {
                    this.druhStanoviska = response.data
                })
                .catch(error => { 
                    console.log('Error: ', error)
                })

                api.getStatus()
                .then(response => {
                    this.status = response.data
                })
                .catch(error => { 
                    console.log('Error: ', error)
                })
                this.$progress.finish()

                if (this.itemId === -1) {
                    this.item = {
                        'id': -1,
                        'idZakazka': -1,
                        'idNadrazenePodani': -1,
                        'iddoss': -1,
                        'iddossPrac': -1,
                        'dossKontaktEmail': '',
                        'dossKontaktPracovnik': '',
                        'dossKontaktTelefon': '',
                        'poradiPodani': 0,
                        'poradiPodaniInstituce': 0,
                        'predmet': '',
                        'idDruhPodani': -1,
                        'idOdpovednaOsoba': -1,
                        'datumOdeslani': null,
                        'predpokLhuta': null,
                        'lhutaKVyrizeni': null,
                        'cisloJednaci': '',
                        'datumVydaniStanoviska': null,
                        'datumPrijetiStanoviska': null,
                        'cisloJednaciVydani': '',
                        'idDruhStanoviska': -1,
                        'platnostStanoviska': null,
                        'idStatus': -1,
                        'odkazy': [],
                        'soubory': [],
                        'zakazka': '',
                        'instituce': '',
                        'pracoviste': '',
                        'druhPodani': '',
                        'odpovednaOsoba': '',
                        'druhStanoviska': '',
                        'status': '',
                        'gRepre': '',
                        'cislo': '',
                        'platnostNeomezene': false,
                        'poznamka': '',
                        'n': 0,
                        'q': 0,
                        'dossNP': '',
                        'odeslanoNP': null
                    }

                    this.item.idOdpovednaOsoba = this.idUser
                    this.item.idZakazka = this.idZakazka

                    if (this.idPodani !== -1) {
                        this.item.idNadrazenePodani = this.idPodani
                        api.getPodaniForUser(this.idUser, this.item.idZakazka)
                        .then(response => {
                            this.podani = response.data
                        })
                        .catch(error => { 
                            console.log('Error: ', error)
                        })
                    }
                }
                else {
                    this.$progress.start()
                    api.getPodaniById(this.itemId)
                    .then(response => {
                        let ti = response.data
                        if (ti.datumOdeslani !== null) ti.datumOdeslani = dayjs(ti.datumOdeslani).toDate()
                        if (ti.lhutaKVyrizeni !== null) ti.lhutaKVyrizeni = dayjs(ti.lhutaKVyrizeni).toDate()
                        if (ti.datumVydaniStanoviska !== null) ti.datumVydaniStanoviska = dayjs(ti.datumVydaniStanoviska).toDate()
                        if (ti.datumPrijetiStanoviska !== null) ti.datumPrijetiStanoviska = dayjs(ti.datumPrijetiStanoviska).toDate()
                        if (ti.platnostStanoviska !== null) ti.platnostStanoviska = dayjs(ti.platnostStanoviska).toDate()

                        this.item = ti
                        
                        if (this.item.idNadrazenePodani !== -1) {
                            api.getPodaniForUser(this.idUser, this.item.idZakazka)
                            .then(response => {
                                this.podani = response.data
                            })
                            .catch(error => { 
                                console.log('Error: ', error)
                            })
                        }
                    })
                    .catch(error => { 
                        console.log('Error: ', error)
                    })
                    this.$progress.finish()
                }
            },
            saveItem(withClose) {
                if (confirm('Uložit záznam?')) {
                    if (this.item.idZakazka === -1 || this.item.iddoss === -1 || this.item.iddossPrac === -1 || this.item.predmet.length === 0 || this.item.idDruhPodani === -1 
                        || this.item.idStatus === -1) {
                        alert('Záznam nebude uložen. Povinná pole jsou: Zakázka, Instituce, Pracoviště, Předmět, Druh podání, Stav')
                        return false
                    }
                    else
                    {
                        if (this.item.id === -1) {
                            this.$progress.start()
                            api.postPodani(this.item)
                            .then(response => {
                                this.item.id = response.data

                                if (this.$refs.filePodani.files.length > 0) {
                                    api.uploadFileForPodani(this.item.id, 0, this.$refs.filePodani.files[0])
                                    .catch(error => { 
                                        console.log('Error: ', error)
                                    })
                                }

                                if (this.$refs.fileStanovisko.files.length > 0) {
                                    api.uploadFileForPodani(this.item.id, 1, this.$refs.fileStanovisko.files[0])
                                    .catch(error => { 
                                        console.log('Error: ', error)
                                    })
                                }

                                if (this.$refs.fileDokumentace.files.length > 0) {
                                    api.uploadFileForPodani(this.item.id, 2, this.$refs.fileDokumentace.files[0])
                                    .catch(error => { 
                                        console.log('Error: ', error)
                                    })
                                }

                                this.$progress.finish()
                                this.gotoPodani()
                            })
                            .catch(error => { 
                                console.log('Error: ', error)
                                this.$progress.finish()
                                alert('Nastala chyba při ukládání. Záznam nebyl uložen.')
                                this.gotoPodani()
                            })
                        }
                        else {
                            this.$progress.start()
                            api.putPodani(this.item.id, this.item)
                            .then(() => {
                                if (this.$refs.filePodani.files.length > 0) {
                                    // let nazev = this.$refs.filePodani.files[0].name
                                    api.uploadFileForPodani(this.item.id, 0, this.$refs.filePodani.files[0])
                                    .then(response => {
                                        this.item.soubory = this.item.soubory.filter(s => s.typ !== 0)
                                        // this.item.soubory.push({ 'id': -1, 'nazev': nazev, 'typ': 0 })
                                        this.item.soubory.push({ 'id': response.data.id, 'nazev': response.data.nazev, 'typ': response.data.typ, 'export': response.data.export })
                                    })
                                    .catch(error => { 
                                        console.log('Error: ', error)
                                    })
                                }
                                this.$refs.filePodani.value = null

                                if (this.$refs.fileStanovisko.files.length > 0) {
                                    //let nazev = this.$refs.fileStanovisko.files[0].name
                                    api.uploadFileForPodani(this.item.id, 1, this.$refs.fileStanovisko.files[0])
                                    .then(response => {
                                        // this.item.soubory = this.item.soubory.filter(s => s.typ !== 1)
                                        // this.item.soubory.push({ 'id': -1, 'nazev': nazev, 'typ': 1 })
                                        this.item.soubory.push({ 'id': response.data.id, 'nazev': response.data.nazev, 'typ': response.data.typ, 'export': response.data.export })
                                    })
                                    .catch(error => { 
                                        console.log('Error: ', error)
                                    })
                                }
                                this.$refs.fileStanovisko.value = null

                                if (this.$refs.fileDokumentace.files.length > 0) {
                                    //let nazev = this.$refs.fileDokumentace.files[0].name
                                    api.uploadFileForPodani(this.item.id, 2, this.$refs.fileDokumentace.files[0])
                                    .then(response => {
                                        //this.item.soubory.push({ 'id': -1, 'nazev': nazev, 'typ': -1 })
                                        this.item.soubory.push({ 'id': response.data.id, 'nazev': response.data.nazev, 'typ': response.data.typ, 'export': response.data.export })
                                    })
                                    .catch(error => { 
                                        console.log('Error: ', error)
                                    })
                                }
                                this.$refs.fileDokumentace.value = null

                                if (withClose) {
                                    this.$emit('backToSeznamPodani')
                                }
                            })
                            .catch(error => { 
                                console.log('Error: ', error)
                                alert('Nastala chyba při ukládání. Záznam nebyl uložen.')
                            })
                            this.$progress.finish()
                        }
                    }
                }
            },
            removeCesta(path) {
                this.item.odkazy = this.item.odkazy.filter(o => o !== path)
            },
            addCesta() {
                if (this.dokumentace.lengt === 0) return
                if (this.item.odkazy.filter(o => o === this.dokumentace).length > 0) return
                this.item.odkazy.push(this.dokumentace)
            },
            gotoPodani() {
                this.$emit('gotoPodani', this.item.idZakazka)
            },
            close() {
                if (this.item.idNadrazenePodani === -1)
                    this.$emit('backToPodani', this.item.id)
                else
                    this.$emit('backToPodani', this.item.idNadrazenePodani)
            },
            platnostNeomezeneChecked() {
                if (this.item.platnostNeomezene)
                    this.item.platnostStanoviska = null
            },
            priloha(id) {
                if (this.item.soubory === undefined || this.item.soubory.length === 0)
                    return ''
                let index = this.item.soubory.findIndex(s => s.id === id)
                if (index === -1)
                    return ''
                else
                    return '<a target="_blank" href="' + process.env.VUE_APP_API_URL + '/Podani/download?id=' + this.item.soubory[index].id + '">' + this.item.soubory[index].nazev + '</a>'
            },
            removePriloha(id) {
                this.item.soubory = this.item.soubory.filter(s => s.id !== id)
            },
            formatDate(date) {
                return date !== null ? dayjs(date).format('D.M.YYYY') : ''
            },
            stanovisko(id) {
                if (this.item.soubory === undefined || this.item.soubory.length === 0)
                    return ''
                let index = this.item.soubory.findIndex(s => s.id === id)
                if (index === -1)
                    return ''
                else
                    return '<a target="_blank" href="' + process.env.VUE_APP_API_URL + '/Podani/download?id=' + this.item.soubory[index].id + '">' + this.item.soubory[index].nazev + '</a>'
            },
            removeStanovisko(id) {
                this.item.soubory = this.item.soubory.filter(s => s.id !== id)
            }
        },
        created() {
            this.load()
        }
    }
</script>